"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eitherFieldRequired = exports.phoneOptional = exports.emailOptional = exports.passwordEquals = exports.fieldRequired = exports.passwordStrength = exports.phoneBody = exports.phone = exports.email = exports.required = void 0;
exports.required = function (value) { return value ? undefined : 'required'; };
// tslint:disable-next-line:max-line-length
exports.email = function (value) { return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) ? undefined : 'emailFormat'; };
exports.phone = function (value) { return /^[0-9\-]{5,}$/.test(value) ? undefined : 'phoneFormat'; };
exports.phoneBody = function (value) { return /^[0-9]{8,}$/.test(value) ? undefined : 'phoneFormat'; };
exports.passwordStrength = function (value) { return value.length >= 6 &&
    value.length < 60 &&
    uniqueCharactersCheck(value, 2) ? undefined : 'passwordStrength'; };
exports.fieldRequired = function (fieldName) { return function (value) { return value ? undefined : fieldName + "Required"; }; };
exports.passwordEquals = function (a) { return function (b) {
    return a === b ? undefined : 'passwordNotEquals';
}; };
exports.emailOptional = function (values) { return !values[0] || /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(values[0]) ? undefined : 'emailFormat'; };
exports.phoneOptional = function (values) { return !values[0] || /^[0-9\-]{5,}$/.test(values[0]) ? undefined : 'phoneFormat'; };
exports.eitherFieldRequired = function (fieldNames) { return function (values) { return values.some(function (value) { return value; }) ? undefined : fieldNames.join('Or') + "Required"; }; };
// the number of the unique characters of the input string should be greater than lowerLimit.
function uniqueCharactersCheck(str, lowerLimit) {
    var characterHolder = new Set();
    for (var i = 0; i < str.length; i++) {
        characterHolder.add(str[i]);
    }
    if (characterHolder.size >= lowerLimit) {
        return true;
    }
    else {
        return false;
    }
}
